import { NavLink, useLocation } from 'react-router-dom'
import { useSession } from '../../session'

// Tabs across the top of the Inventory pages, like Sales and Purchase.
// Approvals only shows for admins, Bins only when bin tracking is on.
// Counts shows how many counts wait for an admin.
export default function InventoryTabs() {
  const { roles, approvals, binTracking, has } = useSession()
  const { pathname } = useLocation()
  const tabs = [
    { to: '/inventory', label: 'Summary', end: true },
    { to: '/inventory/stock', label: 'Stock' },
    ...(has('production') ? [{ to: '/inventory/materials', label: 'Raw materials' }] : []),
    { to: '/inventory/movements', label: 'Moves' },
    { to: '/inventory/counts', label: 'Counts', count: approvals.counts },
    ...(has('production') ? [{ to: '/inventory/production', label: 'Production' }] : []),
    ...(roles.includes('admin') ? [{ to: '/inventory/valuation-approvals', label: 'Approvals', count: approvals.valuation }] : []),
    ...(binTracking ? [{ to: '/inventory/sku-bins', label: 'Bins', also: ['/inventory/bin-move-sku', '/inventory/bin-adjust-sku', '/inventory/areas'] }] : []),
  ]
  return (
    <nav className="section-tabs" aria-label="Inventory">
      {tabs.map(({ to, label, end, count, also }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => (isActive || also?.some((p) => pathname.startsWith(p)) ? 'active' : undefined)}>
          {label}
          {count > 0 && <span className="section-tab-count">{count}</span>}
        </NavLink>
      ))}
    </nav>
  )
}
